<template>
  <div :class="['localidade-filter', `localidade-filter--${layout}`]">
    <div class="localidade-filter__field" :class="{ 'filter-group': layout === 'group' }">
      <label v-if="showLabels" class="localidade-filter__label">{{ stateLabel }}</label>
      <b-form-select
        :value="state"
        :options="stateOptions"
        :class="selectClass"
        @input="onStateInput"
      />
    </div>

    <div class="localidade-filter__field" :class="{ 'filter-group': layout === 'group' }">
      <label v-if="showLabels" class="localidade-filter__label">{{ cityLabel }}</label>
      <b-form-select
        :value="city"
        :options="cityOptions"
        :disabled="!state"
        :class="selectClass"
        @input="onCityInput"
      />
    </div>
  </div>
</template>

<script>
import { api } from '@/services'
import { DB_ROUTES } from '../../../constants'

let cachedLocations = null

export default {
  name: 'LocalidadeFilter',
  props: {
    state: {
      type: [String, null],
      default: null
    },
    city: {
      type: [String, null],
      default: null
    },
    layout: {
      type: String,
      default: 'group',
      validator: value => ['group', 'inline'].includes(value)
    },
    showLabels: {
      type: Boolean,
      default: true
    },
    stateLabel: {
      type: String,
      default: 'Estado'
    },
    cityLabel: {
      type: String,
      default: 'Cidade'
    },
    statePlaceholder: {
      type: String,
      default: 'Todos os estados'
    },
    cityPlaceholder: {
      type: String,
      default: 'Todas as cidades'
    },
    selectClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      allLocalidades: [],
      loading: false
    }
  },
  computed: {
    stateOptions () {
      const states = [...new Set(this.allLocalidades.map(loc => loc.state))]
        .sort((a, b) => a.localeCompare(b, 'pt-BR'))
        .map(value => ({ value, text: value }))

      return [{ value: null, text: this.statePlaceholder }, ...states]
    },
    cityOptions () {
      if (!this.state) {
        return [{ value: null, text: this.cityPlaceholder }]
      }

      const cities = this.allLocalidades
        .filter(loc => loc.state === this.state)
        .map(loc => loc.city)

      const uniqueCities = [...new Set(cities)]
        .sort((a, b) => a.localeCompare(b, 'pt-BR'))
        .map(value => ({ value, text: value }))

      return [{ value: null, text: this.cityPlaceholder }, ...uniqueCities]
    }
  },
  mounted () {
    this.loadLocalidades()
  },
  methods: {
    async loadLocalidades () {
      if (cachedLocations) {
        this.allLocalidades = cachedLocations
        return
      }

      this.loading = true
      try {
        const response = await api.get(DB_ROUTES.GET_ALL_LOCATIONS)
        cachedLocations = response.data || []
        this.allLocalidades = cachedLocations
      } catch (error) {
        console.error('Erro ao carregar localidades:', error)
        this.$emit('error', error)
      } finally {
        this.loading = false
      }
    },
    onStateInput (value) {
      this.$emit('update:state', value)
      this.$emit('update:city', null)
      this.$emit('change', { state: value, city: null })
    },
    onCityInput (value) {
      this.$emit('update:city', value)
      this.$emit('change', { state: this.state, city: value })
    }
  }
}
</script>

<style scoped>
.localidade-filter--group {
  display: contents;
}

.localidade-filter--group .localidade-filter__field {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.localidade-filter--inline {
  display: contents;
}

.localidade-filter--group .localidade-filter__field.filter-group .localidade-filter__label {
  font-weight: 600;
  color: #2c3e50;
  font-size: 1rem;
  margin: 0;
}
</style>
